import { ReferenceLinesTool, StackScrollTool } from "@cornerstonejs/tools";
import React, { useContext, useState } from "react";
import { HIDE_TOOL_SMALL_SCREEN, VIEWPORT_TOOLS } from "../../../../constants/Constants";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import {
  FlipHorizontally,
  FlipVertically,
  originalResolution,
  reset,
  setInvert,
  setRotation,
} from "../../helpers/CornerstoneViewportService";
import GetToolSVG from "../Tools/ToolComponents/GetToolSVG";
import { useTranslation } from "react-i18next";
import {
  disableStackScrollSync,
  enableStackScrollSync,
} from "../../helpers/StackScrollSyncService";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../helpers/Amplitude";
import userContext from "../../../../context/users/UserContext";
import $ from "jquery";
import { canReferenceLinesBeEnabled } from "../../helpers/ViewerHelperService";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";

const DropDownToolElement = ({ tool, setShowDropDown }) => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const {
    activeTool,
    setActiveTool,
    previousActiveTool,
    setPreviousActiveTool,
    activeViewportIndex,
    setIsSynchronizedEnabled,
    isSynchronizedEnabled,
    setIsCineEnabled,
    isCineEnabled,
    annotationData,
    annotationDataAI,
    addedAnnotation,
    setIsReferenceLinesEnabled,
    isReferenceLinesEnabled,
    setIsReferenceLineActivated,
    viewportSeriesData,
    viewportRow,
    viewportColumn,
    boundingBoxMode,
    setBoundingBoxMode,
    isCropEnable, setIsCropEnable
  } = useContext(ViewportContext);

  const {maskImages, setMaskImages} = useContext(studyviewerContext);
const {activeThumbnailIndex} = useContext(ThumbnailContext);
  const { setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);

  const { username } = useContext(userContext);

  const changeActiveTool = (tool) => {
    const isBBMode = boundingBoxMode;
    const isCropMode =  isCropEnable;

    setIsCropEnable(false);
    setBoundingBoxMode(false);
    setShowDropDown(false);
    if ((!isBBMode && !isCropMode )&& activeTool === tool.key) {
      setPreviousActiveTool(activeTool);
      setActiveTool(StackScrollTool.toolName);
    } else {
      setPreviousActiveTool(activeTool);
      setActiveTool(tool.key);
      if (tool.isEvent) {
        logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
      }
    }
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleViewportClickTool = async (tool) => {
    setShowDropDown(false);
    switch (tool.key) {
      case "Invert":
        await setInvert(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateRight":
        await setRotation(activeViewportIndex, 90);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateLeft":
        await setRotation(activeViewportIndex, -90);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipVertical":
        await FlipVertically(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipHorizontal":
        await FlipHorizontally(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "Reset":
        // await originalResolution(activeViewportIndex);
        await reset(activeViewportIndex, annotationData, annotationDataAI, addedAnnotation, false,maskImages, activeThumbnailIndex);
         setMaskImages(maskImages);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "Synchronize":
        if (
          !isSynchronizedEnabled &&
          activeTool === ReferenceLinesTool.toolName
        ) {
          changeActiveTool(StackScrollTool.toolName);
        }
        if (!isSynchronizedEnabled) {
          enableStackScrollSync(activeViewportIndex);
          if (tool.isEvent) {
            logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
          }
          setIsReferenceLineActivated(false);
          setIsReferenceLinesEnabled(false);
        } else {
          disableStackScrollSync();
        }
        
        setIsSynchronizedEnabled(!isSynchronizedEnabled);

        break;
      case "CINE":
        setIsCineEnabled(!isCineEnabled);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "ReferenceLines":
        if (!isReferenceLinesEnabled) { 
          if (!canReferenceLinesBeEnabled(viewportSeriesData, viewportRow, viewportColumn)) {
            setAlertSuccessModal(() => {
              const newItem = { ...alertSuccessModal };
              newItem.show = true;
              newItem.heading = "Alert";
              newItem.isError = false;
              newItem.isSuccess = false;
              newItem.isWarning = true;
              newItem.description = t(
                "viewer.tools.cannot-enable-reference-line"
              );
              return newItem;
            });
            return;
          }
          setIsSynchronizedEnabled(false);
        }
        setIsReferenceLineActivated(!setIsReferenceLineActivated);
        setIsReferenceLinesEnabled(!isReferenceLinesEnabled);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      default:
        break;
    }
    const viewportContainer = $(`#viewport-box-${activeViewportIndex}`);
    viewportContainer.addClass("blinking");
    setTimeout(() => {
      viewportContainer.removeClass("blinking");
    }, 1000);
  };

  if (!VIEWPORT_TOOLS.includes(tool.key)) {
    return (
      <>
        <div
          style={{
            height: "40px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          className={`${HIDE_TOOL_SMALL_SCREEN?.includes(tool.key)?"show-hidden-tools":""}`}
          onClick={() => changeActiveTool(tool)}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <div className="highlight-tool">
            <GetToolSVG toolName={tool.key} hovered={hovered} />
          </div>
          <span style={{ marginLeft: "10px" }}>{t(tool.name)}</span>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div
          style={{
            height: "40px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          onClick={() => {
            handleViewportClickTool(tool);
          }}
          className={`${HIDE_TOOL_SMALL_SCREEN?.includes(tool.key)?"show-hidden-tools":""}`}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <div className="highlight-tool">
            <GetToolSVG toolName={tool.key} hovered={hovered} />
          </div>
          <span style={{ marginLeft: "10px" }}>{t(tool.name)}</span>
        </div>
      </>
    );
  }
};

export default DropDownToolElement;
